import { CsatField } from '@tm/shared-lib/src/field'
import React from 'react'
import { useSurveyValue } from '../../hooks/useSurveyValue'
import { Range } from '../field/Range'

interface Props {
  field: CsatField
  //defaultLabels?: boolean
  //theme: Theme
}

export function CsatQuestion({ field }: Props): JSX.Element {
  const [value, setValue] = useSurveyValue(field)
  if (value !== null && value !== undefined && typeof value !== 'string' && typeof value !== 'number') {
    throw new Error('CSAT does not support value: ' + value)
  }
  return (
    <Range value={value} onValueChange={setValue} {...field} rangeMin={1} rangeMax={5} defaultLabels={true} isCsat />
  )
}
